import { Column, CreateDateColumn, Entity, PrimaryColumn, UpdateDateColumn, VersionColumn } from 'typeorm';

@Entity('dl_production_plan')
export class ProductionPlanEntity {
    @PrimaryColumn('varchar', { name: "production_plan_id", length: 14 })
    productionPlanId: string;

    @PrimaryColumn('varchar', { name: "country", length: 5 })
    country: string;

    @Column('varchar', { name: "season", length: 50, nullable: true })
    season: string;

    @Column('varchar', { name: "business_unit", length: 50, nullable: true })
    businessUnit: string;

    @Column({ type: 'varchar', name: 'style_no', nullable: true })
    styleNo: string;

    @Column({ type: 'varchar', name: 'phase', nullable: true })
    phase: string;

    @Column({ type: 'text', name: 'item_name', nullable: true })
    itemName: string;

    @Column('varchar', { name: "main_sample_code", length: 25, nullable: true })
    mainSampleCode: string;

    @Column('varchar', { name: "trim_order_no", length: 25, nullable: true })
    trimOrderNo: string;

    @Column('varchar', { name: "fabric_order_no", length: 25, nullable: true })
    fabricOrderNo: string;

    @Column('varchar', { name: "po_order_no", length: 25, nullable: true })
    poOrderNo: string;

    @Column('varchar', { name: "production_month", length: 25, nullable: true })
    productionMonth: string;

    @Column('varchar', { name: "production_plan_type_name", length: 15, nullable: true })
    productionPlanTypeName: string;

    @Column({ type: 'date', name: 'wh_date', nullable: true })
    whDate: Date;

    @Column({ type: 'date', name: 'contract_date', nullable: true })
    contractDate: Date;

    @Column({ type: 'date', name: 'exf_date', nullable: true })
    exfDate: Date;

    @Column({ type: 'float', name: 'fab_oqyt', nullable: true, default: 0 })
    fabOqyt: number;

    @Column({ type: 'float', name: 'trim_oqty', nullable: true, default: 0 })
    trimOqty: number;

    @Column({ type: 'float', name: 'po_oqty', nullable: true, default: 0 })
    poOqty: number;

    @Column({ type: 'float', name: 'fab_body_consumption', nullable: true })
    fabBodyConsumption: number;

    @Column({ type: 'float', name: 'fab_body_requirement', nullable: true })
    fabBodyRequirement: number;

    @Column({ type: 'float', name: 'fab_consumption_with_trims', nullable: true })
    fabConsumptionWithTrims: number;

    @Column({ type: 'float', name: 'fab_requirement_with_trims', nullable: true })
    fabRequirementWithTrims: number;

    @Column({ type: 'date', name: 'fab_request_date', nullable: true })
    fabRequestDate: Date;

    @Column({ type: 'date', name: 'fabric_answer_date', nullable: true })
    fabricAnswerDate: Date;

    @Column({ type: 'date', name: 'fabric_actual_date', nullable: true })
    fabricActualDate: Date;

    @Column({ type: 'date', name: 'trim_answer_date', nullable: true })
    trimAnswerDate: Date;

    @Column({ type: 'date', name: 'trim_request_date', nullable: true })
    trimRequestDate: Date;

    @Column({ type: 'date', name: 'trim_actual_date', nullable: true })
    trimActualDate: Date;

    @Column({ type: 'date', name: 'po_answer_date', nullable: true })
    poAnswerDate: Date;

    @Column({ type: 'date', name: 'po_request_date', nullable: true })
    poRequestDate: Date;

    @Column({ type: 'date', name: 'po_actual_date', nullable: true })
    poActualDate: Date;

    @Column('varchar', { name: "sam", nullable: true })
    sam: number;

    @Column('varchar', { name: "keisu", nullable: true })
    keisu: number;

    @Column('varchar', { name: "sam_master", nullable: true })
    samMaster: number;

    @Column({
        nullable: false,
        name: "is_wh_date_revised",
        default: 0
    })
    isWHDateRevised: boolean;


    @CreateDateColumn({
        name: "created_at",
    })
    createdAt: string;

    @Column("varchar", {
        nullable: true,
        length: 40,
        name: "created_user",
    })
    createdUser: string | null;

    @UpdateDateColumn({
        name: "updated_at",
    })
    updatedAt: string;

    @Column("varchar", {
        nullable: true,
        length: 40,
        name: "updated_user",
    })
    updatedUser: string | null;

    @VersionColumn({
        default: 1,
        name: "version_flag",
    })
    versionFlag: number;

    @Column({
        nullable: false,
        name: "is_active",
        default: 1
    })
    isActive: boolean;

    @Column('varchar', { name: 'company_code', length: 20, nullable: true })
    companyCode: string;

    @Column('varchar', { name: 'unit_code', length: 20, nullable: true })
    unitCode: string;

    @Column("uuid")
    fileReferenceId: string;
}